'use client';
import { MinusThinIcon } from '@/icons';
import { cn } from '@/lib/utils';
import { useEffect, useRef, useState } from 'react';

export const ProductPageAccordion = ({
  children,
  heading,
  defaultOpen = true,
}: {
  children: React.ReactNode;
  heading: string;
  defaultOpen?: boolean;
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [contentHeight, setContentHeight] = useState(
    defaultOpen ? '100%' : 0
  );

  const accordionRef = useRef(null);

  useEffect(() => {
    if (accordionRef.current)
      setContentHeight(
        accordionRef.current['scrollHeight'] || 0
      );
  }, []);

  const openHandler = () => {
    setOpen(!open);
  };
  return (
    <div className='border-t border-gray-200'>
      <div
        onClick={openHandler}
        className='flex justify-between items-center cursor-pointer  py-4 hover:bg-gray-50 transition-colors'
      >
        <h4 className='text-[14px] font-medium text-[#101828]'>{heading}</h4>
        <div className='relative'>
          <MinusThinIcon
            className={cn(
              'absolute top-0 left-0 transition-all duration-300 text-gray-600',
              !open && 'rotate-90'
            )}
          />
          <MinusThinIcon className="text-gray-600" />
        </div>
      </div>
      <div
        ref={accordionRef}
        className={cn(
          'transition-all duration-300 h-full overflow-hidden mt-0!'
        )}
        style={{ maxHeight: open ? contentHeight : 0 }}
      >
        <div className='pb-4 pt-0'>{children}</div>
      </div>
    </div>
  );
};
